import * as Styles from "./styles";

export const Header = ({ Title, onClose }) => (
  <Styles.Header>
    <h1>{Title}</h1>
    <Styles.CloseModal onClick={onClose}>X</Styles.CloseModal>
  </Styles.Header>
);
